import React from "react";
import PageSection from "../../Components/PageSection";
import BJMed from "../../images/blackjack-med-medallion.png";


export default class BlackJack extends React.Component {
  render() {
  return (
    <div>
       <PageSection 
          headerText="Black Jack: Behind the Waves" 
          divider="New Release - Behind the World Trilogy" 
          showOppositeSide={false}
          banner="First Book of the Behind the World Trilogy" 
          sectionContent={[
          "A strange tale of Mystery, Mayhem, and Marauders on the modern-day Virginia shore. A blossoming love affair. A lost Spanish treasure galleon. And a looming paranormal struggle between a defrocked priest and a latter-day pirate. All developing on an isolated island off the Virginia coast where a single house still stands defiant despite the storms, the shifting sands, and time.",
              "Black Jack is the first book of the Behind the World trilogy which explores the question of what unsuspected powers lurk in the people around us as we all blithely go about our daily lives. An old woman living out her final years on the third floor of that secluded house seems a kindly soul, a gentle grandmother to the younger residents. But the struggle between",
              "pirate and priest rouses long latent abilities, rising now to enable her to protect her home, her family, and her deep, dark secrets.",
          ]}
          sideLink="https://www.amazon.com/Black-Jack-Behind-Waves-World-ebook/dp/B0FMKPBZ82"
          sidePicture={BJMed}
      />
    </div>
  )}
}